import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, Button, CardHeader } from 'reactstrap';

import { Separator } from '../../../../../components/common/CustomBootstrap';
import { VisitorFormSettings } from './VisitorFormSettings';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  postAPI_Update_VisitorSettings,
  postAPI_Update_LanguageVisitorSettings,
} from '../../../../../constants/APIs';
import parse from 'html-react-parser';
import Validation from '../../../../../components/Validation';
export default function VisitorSettings({
  visitor,
  integrationId,
  integrationLanguages,
  locale,
  languagevisitor,
  LoadIntegration,
}) {
  // console.log('nudges', nudges);
  const [isUpdating, setIsUpdating] = useState(false);
  const [visitorData, setVisitorData] = useState(visitor);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  useEffect(() => {
    setVisitorData(visitorData);
  }, []);

  const edit = (data) => {
    setVisitorData(data);
    setIsUpdating(true);
  };
  const handleSubmit = (updateVisitorData) => {
    // console.log(JSON.stringify(updateVisitorData));
    var body = {
      title: updateVisitorData.title,
      buttonText: updateVisitorData.buttonText,
      fields: updateVisitorData.fields,
      enabled: updateVisitorData.enabled,
      subTitle: updateVisitorData.subTitle,
      checkboxText: updateVisitorData.checkboxText,
      preChatType: updateVisitorData?.preChatType || 'Form',
      ssoIntegrationId: updateVisitorData?.ssoIntegrationId || '',
    };
    try {
      return AxiosAPI({
        method: 'put',
        url: `${postAPI_Update_VisitorSettings}/${integrationId}?group_id=${getGroupID()}`,
        data: body,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          setVisitorData(updateVisitorData);
          LoadIntegration();
          setIsUpdating(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleLanguageSubmit = (updateVisitorData) => {
    // console.log(JSON.stringify(updateVisitorData));
    var body = {
      title: updateVisitorData.title,
      buttonText: updateVisitorData.buttonText,
      fields: updateVisitorData.fields,
      subTitle: updateVisitorData.subTitle,
      checkboxText: updateVisitorData.checkboxText,
      languageCode: updateVisitorData.languageCode,
      preChatType: updateVisitorData?.preChatType || 'Form',
      ssoIntegrationId: updateVisitorData?.ssoIntegrationId || '',
    };
    try {
      return AxiosAPI({
        method: 'put',
        url: `${postAPI_Update_LanguageVisitorSettings}/${integrationId}?group_id=${getGroupID()}`,
        data: body,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          LoadIntegration();
          setIsUpdating(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  // console.log(visitorData);
  return (
    <Fragment>
      <Card className="mb-4">
        <CardHeader>
          <h6 className="text-center mt-4">Pre & Post Chat Form</h6>
          <p className="text-center">
            These forms are optional and can be tailored to your business's
            preferences, but they can enhance guest interactions.
          </p>
        </CardHeader>
        <Separator className="" />
        <CardBody className="ml-2">
          <h6 className="text-left">Pre Chat Form</h6>
          <p>
            Before a guest starts conversing with the Chatbot, you can ask for
            primary information.
          </p>
          <Separator className="mb-3" />
          <div className="text-left" style={{ marginTop: '25px' }}>
            <span style={{ fontSize: '14px' }}>
              <b>Type:</b>
            </span>
            <p className="mb-2">
              {visitorData !== null ? visitorData.preChatType : ''}
            </p>
            {visitorData !== null && visitorData.preChatType === 'SSO' ? (
              <>
                <span style={{ fontSize: '14px' }}>
                  <b>Message:</b>
                </span>
                <p className="mb-2">
                  {visitorData !== null && visitorData.title
                    ? visitorData.title
                    : null}
                </p>
                <span style={{ fontSize: '14px' }}>
                  <b>Button Text:</b>
                </span>
                <p className="mb-2">
                  {visitorData !== null && visitorData.buttonText
                    ? visitorData.buttonText
                    : null}
                </p>
              </>
            ) : (
              <>
                <span style={{ fontSize: '14px' }}>
                  <b>Enable:</b>
                </span>
                <p className="mb-2">
                  {visitorData !== null &&
                  visitorData.enabled !== null &&
                  visitorData.enabled
                    ? 'Yes'
                    : 'No'}
                </p>
                <span style={{ fontSize: '14px' }}>
                  <b>Title:</b>
                </span>
                <p className="mb-2">
                  {visitorData !== null && visitorData.title
                    ? visitorData.title
                    : null}
                </p>
                <span style={{ fontSize: '14px' }}>
                  <b>Subtitle:</b>
                </span>
                <p className="mb-2">
                  {visitorData !== null &&
                  visitorData.subTitle &&
                  visitorData.subTitle != null
                    ? parse(visitorData.subTitle)
                    : null}
                </p>
                <span style={{ fontSize: '14px' }}>
                  <b>Button Text:</b>
                </span>
                <p className="mb-2">
                  {visitorData !== null && visitorData.buttonText
                    ? visitorData.buttonText
                    : null}
                </p>
                <span style={{ fontSize: '14px' }}>
                  <b>Checkbox Text:</b>
                </span>
                <p className="mb-2">
                  {visitorData !== null &&
                  visitorData?.checkboxText &&
                  visitorData.checkboxText != null
                    ? parse(visitorData.checkboxText)
                    : null}
                </p>
                <span style={{ fontSize: '14px' }}>
                  <b>Fields:</b>
                </span>
                <p className="mb-2">
                  {visitorData !== null && visitorData.fields
                    ? visitorData.fields.map((elem, index) => {
                        if (visitorData.fields.length > index + 1) {
                          return elem.field + ',';
                        }
                        return elem.field;
                      })
                    : null}
                </p>
              </>
            )}
            <Separator className="mb-2" />
            <div className="text-center">
              <Button
                className="text-center"
                size="xs"
                color="success"
                outline
                style={{ marginTop: '3px' }}
                onClick={() => edit(visitorData)}
              >
                Edit
              </Button>
            </div>
          </div>
        </CardBody>
        {isUpdating && (
          <VisitorFormSettings
            formLabel="Update Pre Chat Form"
            visible={isUpdating}
            toggle={() => {
              setIsUpdating(!isUpdating);
            }}
            submit={handleSubmit}
            handleLanguageSubmit={handleLanguageSubmit}
            visitorData={visitorData}
            integrationLanguages={integrationLanguages}
            locale={locale}
            languagevisitor={languagevisitor}
          />
        )}
      </Card>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
